import { Injectable } from '@angular/core';
import { EntityState, EntityStore } from '@examdojo/state';
import { ClassAssignmentProps, ClassAssignmentStoreModel } from './class-assignment.model';

export type ClassAssignmentState = EntityState<ClassAssignmentStoreModel, ClassAssignmentProps>;

@Injectable({ providedIn: 'root' })
export class ClassAssignmentStore extends EntityStore<ClassAssignmentState, ClassAssignmentStoreModel, 'id'> {
  constructor() {
    super({
      name: 'class-assignments',
      idKey: 'id',
      initialPropsState: { weeklyPublishMarksLimit: 60 },
    });
  }
}
